<template>
  <section id="tachi15Home">
    <b-container>
      <b-row>
        <b-col>
          <h3>Start fast. ¥15M for 15% within 15 days.</h3>
        </b-col>
      </b-row>

      <b-row class="wrapper">
        <b-col md="3" class="wrapperCol">
          <img src="../assets/15M-¥-gris.png">
          <p>With the Tachi.ai 15, we’ll finance your business' initial launch with ¥15 million under a simple, straightforward deal structure.</p>
        </b-col>
        <b-col md="3" class="wrapperCol">
          <img src="../assets/15-gris.png">
          <p>For eligible startups, Tachi.ai Ventures will invest in exchange for 15% of your startup’s equity, legal fees included.</p>
        </b-col>
        <b-col md="3" class="wrapperCol">
          <img src="../assets/15days-gris.png">
          <p>Your time as an entrepreneur is precious. That’s why we guarantee you an investment decision within 15 days.</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <!-- add  @click.native.prevent="changeShowContactForm"-->
          <app-button @click.native.prevent="changeShowContactForm">Check your eligibility</app-button>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import RedButton from "./Reusable/RedButton.vue";
export default {
  data() {
    return {};
  },
  components: {
    "app-button": RedButton
  },
  methods: {
    changeShowContactForm() {
      this.$emit("changeShowContactForm");
    }
  }
};
</script>

<style>
#tachi15Home {
  padding: 50px 0;
  display: flex;
  text-align: center;
}

#tachi15Home h3 {
  font-size: 1.8rem;
}

#tachi15Home .wrapper {
  padding: 50px 50px;
  text-align: justify;
  justify-content: center;
  font-size: 1.1rem;
}

#tachi15Home .wrapperCol {
  margin: 30px;
}

#tachi15Home img {
  max-width: 100%;
  height: auto;
  max-height: 100%;
}
</style>
